import __request__ from "routing/request";
export function getJournalEstimate() {
  return __request__("GET", "/migration/journalestimate", null, {}, {
    "Accept": ["application/json"]
  });
}
export function serialize() {
  return __request__("GET", "/migration/serialize", null, {}, {
    "Accept": ["text/plain"]
  });
}
export function status() {
  return __request__("GET", "/migration/state", null, {}, {
    "Accept": ["application/json"]
  });
}
export function resetState() {
  return __request__("DELETE", "/migration/state", null, {}, {
    "Accept": ["application/json"]
  });
}
export function trigger(request) {
  return __request__("POST", "/migration/trigger", request, {}, {
    "Accept": ["application/json"]
  });
}
